<template>
  <div class="root">
    <table class="table">
      <tr class="first_tr">
        <th>登记编号</th>
        <th>抵押物类别</th>
        <th>位置</th>
        <th>抵押人申请</th>
        <th>登记时间</th>
      </tr>
      <tr v-for="(item, index) in list0" :key="index">
        <!-- @click="torongzi(item)" -->
        <td>{{ item.cid }}</td>
        <td>{{ item.type }}</td>
        <td>{{ item.address }}</td>
        <td>{{ item.dyname }}</td>
        <td>{{ item.registertime }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list0: [],
    }
  },
  created() {
    // 融资公告数据
    // let url = "rongzigonggao";
    // console.log("融资公告");
    // console.log(this.ajax_url(url).data);
    // this.list0 = this.ajax_url(url).data;
    // if (this.$route.query.address !== undefined) {
    //   let url1 = 'rongzichaxun';
    //   console.log('查询结果');
    //   console.log(this.ajax_data(url1, this.$route.query).data);
    //   this.list0 = this.ajax_data(url1, this.$route.query).data;
    // }
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    // 跳转到交易项目详情
    torongzi(data) {
      this.$router.push({ path: '/financing/detail', query: { id: data.id } })
    },
  },
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 30px;
  padding: 40px 280px 160px 280px;
  width: 1300px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
}

.table {
  width: 100%;
}

.first_tr {
  height: 54px;
  background: #d8dff9;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 28px;
  color: #333333;
}

td {
  max-width: 260px;
  height: 56px;
  font-size: 20px;
  font-family: MicrosoftYaHei;
  line-height: 56px;
  text-align: center;
  color: #333333;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

tr {
  cursor: pointer;
}
</style>
